import { SectionBody } from './SectionBody'
import { SectionContainer } from './SectionContainer'
import { SectionTitle } from './SectionTitle'
import './styles.scss'

export const Section = {
  container: SectionBody,
  title: SectionTitle,
  root: SectionContainer,
}
